import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export const useQueryLargestDeletedActivitiesTableData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['largestDeletedActivitiesTableData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
